export default function calculateBytes(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const decimal = i > 2 ? 2 : null;
  return "".concat((bytes / k ** i).toFixed(decimal), " ").concat(sizes[i]);
}